<mat-toolbar #navToolBar layout="row" class="iwg-navbar md-iwgNavbar-them iwg-standard-logo" color="accent"
    *ngIf="nav.visible || isNavActive">
    <div class="mat-toolbar-tools navbutton">
        <button mat-button [ngClass]="{'active-list-item':nav.activeMenu==='dashboard' || navMenuName === 'dashboard'}"
            (click)="OnDashboardclick()">
            Dashboard
            <mat-ink-bar [ngClass]="{'textSuccess':nav.activeMenu=='dashboard' || navMenuName === 'dashboard' }"></mat-ink-bar>
        </button>
        <button mat-button [ngClass]="{'active-list-item':nav.activeMenu==='services' || navMenuName === 'services'}" [matMenuTriggerFor]="services">
            Services
            <mat-ink-bar [ngClass]="{'textSuccess':nav.activeMenu==='services' || navMenuName === 'services' }"></mat-ink-bar>
        </button>
        <button mat-button *ngIf="ShowInvoice" [ngClass]="{'active-list-item':nav.activeMenu==='invoices' || navMenuName === 'invoices'}"
            [matMenuTriggerFor]="invoices">
            Invoices
            <mat-ink-bar [ngClass]="{'textSuccess':nav.activeMenu==='invoices' || navMenuName === 'invoices'}"></mat-ink-bar>
        </button>
        <button mat-button *ngIf="ShowMyTalent && IsWorker && HasWorkerProfile"
            (click)="OnClick('worker-profile-detail','worker-profile-detail', null)"
            [ngClass]="{'active-list-item':nav.activeMenu==='my-talent' || navMenuName === 'my-talent' }">
            MyTalent
            <mat-ink-bar [ngClass]="{'textSuccess':nav.activeMenu==='my-talent' || navMenuName === 'my-talent'}"></mat-ink-bar>
        </button>
        <button mat-button *ngIf="ShowMyTalent && IsWorker && !HasWorkerProfile"
            (click)="OnClick('myGuides','worker-profile', null)"
            [ngClass]="{'active-list-item':nav.activeMenu==='my-talent' || navMenuName === 'my-talent' }">
            MyTalent
            <mat-ink-bar [ngClass]="{'textSuccess':nav.activeMenu==='my-talent' || navMenuName === 'my-talent'}"></mat-ink-bar>
        </button>
        <button mat-button *ngIf="ShowMyTalent && !IsWorker"
            [ngClass]="{'active-list-item':nav.activeMenu==='my-talent' || navMenuName === 'my-talent'}" [matMenuTriggerFor]="mytalent">
            MyTalent
            <mat-ink-bar [ngClass]="{'textSuccess':nav.activeMenu==='my-talent' || navMenuName === 'my-talent'}"></mat-ink-bar>
        </button>
        <button mat-button (click)="OnClick('sales','us-eor-quotes', null)"
            [ngClass]="{'active-list-item':nav.activeMenu==='sales' || navMenuName === 'sales'}" *ngIf="ShowUSEORQuotes">
            Sales
            <mat-ink-bar [ngClass]="{'textSuccess':nav.activeMenu === 'sales' || navMenuName === 'sales'}"></mat-ink-bar>
        </button>

        <button mat-button (click)="OnClick('myGuides','myGuides', null)"
            [ngClass]="{'active-list-item':nav.activeMenu==='myGuides' || navMenuName === 'myGuides'}" *ngIf="ShowCountryGuides">MyGuides
            <mat-ink-bar [ngClass]="{'textSuccess':nav.activeMenu==='myGuides' || navMenuName === 'myGuides'}"></mat-ink-bar>
        </button>

        <mat-menu #services="matMenu">
            <button mat-menu-item [matMenuTriggerFor]="empOfRecord" *ngIf="ShowEOR">
                Employer of Record <span class="nvspan"></span>
            </button>
            <button mat-menu-item [matMenuTriggerFor]="compliance" *ngIf="ShowCompliance">
                Compliance <span class="nvspan"></span>
            </button>
            <button mat-menu-item [matMenuTriggerFor]="agentOfRecord" *ngIf="ShowAOR">
                Agent of Record <span class="nvspan"></span>
            </button>
        </mat-menu>

        <mat-menu #empOfRecord="matMenu" class="submenu">
            <button mat-menu-item (click)="activeNav('services')" *ngIf="ShowEOREstimator"
                (click)="showQuoteEstimator($event)">Estimator</button>
            <button mat-menu-item (click)="OnClick('services', 'quotes', 1)" *ngIf="ShowEORQuotes">Quotes</button>
            <button mat-menu-item (click)="OnClick('services', 'assignments', 1)">Assignments</button>
        </mat-menu>
        
        <mat-menu #compliance="matMenu" class="submenu">
            <button mat-menu-item *ngIf="ShowComplianceQuotes"
                (click)="OnClick('services', 'quotes', 3)">Quotes</button>
            <button mat-menu-item (click)="OnClick('services', 'assignments', 3)">Evaluations</button>
        </mat-menu>

        <mat-menu #agentOfRecord="matMenu" class="submenu">
            <button mat-menu-item *ngIf="ShowAORQuotes" (click)="OnClick('services', 'quotes', 2)">Quotes</button>
            <button mat-menu-item (click)="OnClick('services', 'assignments', 2)">Engagements</button>
        </mat-menu>

        <mat-menu #invoices="matMenu">
            <button mat-menu-item *ngIf="ShowiWGInvoices" (click)="OnClick('invoices', 'invoices', null)">
                iWorkGlobal Invoices<span class="nvspan"></span>
            </button>
            <button mat-menu-item *ngIf="ShowContractorInvoices" (click)="OnClick('invoices', 'vendor-invoices', null)">
                Contractor Invoices<span class="nvspan"></span>
            </button>
        </mat-menu>
        <mat-menu #mytalent="matMenu">
            <button mat-menu-item *ngIf="!IsWorker" (click)="OnClick('my-talent-rate', 'my-talent-rate', null)">
                Rate<span class="nvspan"></span>
            </button>
            <button mat-menu-item *ngIf="!IsWorker"
                (click)="OnClick('my-talent-search', 'my-talent-search', null)">
                Search<span class="nvspan"></span>
            </button>
        </mat-menu>

    </div>
    <span [ngStyle]="{'margin-left': 'auto'}"></span>
  

    <div class="iwg-navbar-avatar ng-binding">
        {{userInitials}}
    </div>

    <div class="mat-toolbar-tools">

        <button mat-button class="nav-catet-right-align showxs" [matMenuTriggerFor]="topnav">
            <mat-icon class="ng-scope md-iwgNavbar-theme material-icons">menu</mat-icon>
        </button>
        <mat-menu #topnav="matMenu">
            <button mat-menu-item (click)="OnDashboardclick()">Dashboard</button>
            <mat-divider></mat-divider>

            <button mat-menu-item *ngIf="!EORDisabled" disabled="disabled">Employer of Record</button>
            <button mat-menu-item (click)="activeNav('services')" *ngIf="!EORDisabled && ShowEOREstimator"
                (click)="showQuoteEstimator($event)">&nbsp;&nbsp;&nbsp;Estimator</button>
            <button mat-menu-item *ngIf="!EORDisabled" (click)="OnClick('services', 'quotes', 1)">&nbsp;&nbsp;&nbsp;Quotes</button>
            <button mat-menu-item *ngIf="!EORDisabled"
                (click)="OnClick('services', 'assignments', 1)">&nbsp;&nbsp;&nbsp;Assignments</button>
            <mat-divider *ngIf="!EORDisabled"></mat-divider>

            <button mat-menu-item *ngIf="!ComplianceDisabled" disabled="disabled">Compliance</button>
            <button mat-menu-item *ngIf="!ComplianceDisabled && ShowComplianceQuotes"
                (click)="OnClick('services', 'quotes', 3)">&nbsp;&nbsp;&nbsp;Quotes</button>
            <button mat-menu-item *ngIf="!ComplianceDisabled"
                (click)="OnClick('services', 'assignments', 3)">&nbsp;&nbsp;&nbsp;Evaluations</button>
            <mat-divider *ngIf="!ComplianceDisabled"></mat-divider>

            <button mat-menu-item *ngIf="!AORDisabled" disabled="disabled">Agent of Record</button>
            <button mat-menu-item *ngIf="!AORDisabled && ShowAORQuotes"
                (click)="OnClick('services', 'quotes', 2)">&nbsp;&nbsp;&nbsp;Quotes</button>
            <button mat-menu-item *ngIf="!AORDisabled"
                (click)="OnClick('services', 'assignments', 2)">&nbsp;&nbsp;&nbsp;Engagements</button>

            <mat-divider *ngIf="!AORDisabled"></mat-divider>

            <button mat-menu-item *ngIf="!InvoicesDisabled" disabled="disabled">Invoices</button>
            <button mat-menu-item *ngIf="!InvoicesDisabled"
                (click)="OnClick('invoices', 'invoices', null)">&nbsp;&nbsp;&nbsp;iWorkGlobal Invoices</button>
            <button mat-menu-item *ngIf="ShowContractorInvoices" (click)="OnClick('invoices', 'vendor-invoices', null)">
                &nbsp;&nbsp;&nbsp;Contractor Invoices
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="OnClick('sales','us-eor-quotes', null)" *ngIf="ShowUSEORQuotes">
            Sales</button>
            <button mat-menu-item *ngIf="!CountryGuidesDisabled"
                (click)="OnClick('myGuides','myGuides', null)">MyGuides</button>
            
            
            <button mat-menu-item (click)="OnClick('worker-profile-detail','worker-profile-detail',null)"
                *ngIf="ShowMyTalent && IsWorker && HasWorkerProfile">MyTalent</button>
            <button mat-menu-item (click)="OnClick('worker-profile','worker-profile',null)"
                *ngIf="ShowMyTalent && IsWorker && !HasWorkerProfile">MyTalent</button>
            <button mat-menu-item (click)="OnClick('my-talent-rate','my-talent-rate',null)"
                *ngIf="ShowMyTalent && !IsWorker">MyTalent Rate</button>
            <button mat-menu-item (click)="OnClick('my-talent-search','my-talent-search',null)"
                *ngIf="ShowMyTalent && !IsWorker">MyTalent Search</button>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="showContactInfo($event)">Update Contact Information</button>
            <button mat-menu-item (click)="logoutUser()">Log Out</button>


        </mat-menu>
        <button class="nav-catet-right-align hidexs no-hoverbg" [matMenuTriggerFor]="morenav">
            <mat-icon style="vertical-align: middle;" class="ng-scope md-iwgNavbar-theme material-icons menu-icon-clr">
                more_vert</mat-icon>
        </button>
        <mat-menu #morenav="matMenu">
            <app-user-links></app-user-links>

            <button mat-menu-item (click)="showContactInfo($event)">Update Contact Information</button>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="logoutUser()">Log Out</button>
        </mat-menu>

    </div>

    <a mat-button (click)="showContactUs($event)" fxHide.xs fxHide.sm
        class="iwg-help-fab mat-fab mat-mini  pointer-cursor vista-help" aria-label="Help" >
        <mat-icon class="help-button mat-icon-no-color" color="accent" >live_help</mat-icon>
    </a>

</mat-toolbar>


<!--<a mat-button (click)="showContactUs($event, false)" fxHide.xs fxHide.sm
        class="iwg-help-fab mat-fab mat-mini login-help pointer-cursor vista-help" aria-label="Help" *ngIf="nav.visible">
        <mat-icon class="help-button mat-icon-no-color" color="accent" >live_help</mat-icon>
</a>-->